import React from "react";
import { IconType } from "./type";

const IconYoutube = ({ width = 26, height = 15, fill = "white" }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.39 0H5.87
  4.31318 0 2.82012 0.618445 1.71928 1.71928C0.618445 2.82012 0 4.31318 0 5.87L0 14.13C0 14.9009 0.151832 15.6642 0.446827 16.3764C0.741822 17.0885 1.1742 17.7356 1.71928 18.2807C2.82012 19.3816 4.31318 20 5.87 20H22.39C23.1609 20 23.9242 19.8482 24.6364 19.5532C25.3485 19.2582 25.9956 18.8258 26.5407 18.2807C27.0858 17.7356 27.5182 17.0885 27.8132 16.3764C28.1082 15.6642 28.26 14.9009 28.26 14.13V5.87C28.26 4.31318 27.6416 2.82012 26.5407 1.71928C25.4399 0.618445 23.9468 0 22.39 0V0ZM18.39 10.4L10.7 14.09C10.6525 14.1141 10.5996 14.1255 10.5464 14.1231C10.4931 14.1208 10.4414 14.1048 10.3962 14.0766C10.351 14.0485 10.3138 14.0092 10.2882 13.9625C10.2626 13.9158 10.2494 13.8633 10.25 13.81V6.21C10.2494 6.15674 10.2626 6.10423 10.2882 6.05753C10.3138 6.01082 10.351 5.97151 10.3962 5.94337C10.4414 5.91523 10.4931 5.89922 10.5464 5.89688C10.5996 5.89453 10.6525 5.90594 10.7 5.93L18.43 9.85C18.4831 9.87429 18.528 9.91357 18.5591 9.963C18.5902 10.0124 18.6062 10.0699 18.6052 10.1283C18.6041 10.1867 18.586 10.2435 18.5531 10.2918C18.5202 10.34 18.474 10.3777 18.42 10.4H18.39Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconYoutube;
